import * as core from '@/application/caseView-core';
import CONST from '@/application/constants';
import i18n from '@/plugins/i18n';

export function getTabsByCaseClassGroupType (caseClassGroupTypeID)
{
  let result = core.getTabsByCaseClassGroupType(caseClassGroupTypeID);
  const index = result.indexOf(CONST.CASE_VIEW_TAB_TICKLERS);
  if (index > -1)
  {
    result.splice(index, 1);
  }
  return result;
}

export function getTabHeaders (tab, isVerifiedParty)
{
  let headers = [];
  if (tab === CONST.CASE_VIEW_TAB_PARTIES)
  {
    headers.push({ text: i18n.t('page.caseView.tab.parties.role'), value: 'partyHeader.partySubType', sortable: true });
    headers.push({ text: i18n.t('page.caseView.tab.parties.name'), value: 'partyHeader.partyActorInstance.sortName', sortable: true });
    if (isVerifiedParty)
    {
      headers.push({ text: i18n.t('page.caseView.tab.parties.birthDate'), value: 'birthDate', sortable: false });
    }
    headers.push({ text: i18n.t('page.caseView.tab.parties.address'), value: 'address.formattedAddress', sortable: false });
    headers.push({ text: i18n.t('page.caseView.tab.parties.status'), value: 'partyHeader.partyStatus', sortable: true });
    headers.push({ text: i18n.t('page.caseView.tab.parties.representation'), value: 'legalRepresentations', sortable: false });
  }
  else
  {
    headers = core.getTabHeaders(tab, isVerifiedParty);
  }
  return headers;
}